import {useFormContext } from 'react-hook-form'
import {
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Input,
    useToast,
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import {getAccount, isAuth, isBonTacosAccount} from "../../../../services/auth";
import React, {ElementRef, useEffect, useReducer, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../../hooks";
import {RootState} from "../../../../store";

export default ({autoClick}:{autoClick: boolean}) => {
    const account = getAccount()
    const {t} = useTranslation();
    const {isLoading} = useAppSelector((state: RootState) => state.orderForm);
    const myRef = useRef(null as null|any);
    const {
        register,
        formState: { errors },
        getValues
    } = useFormContext()
    const navigate = useNavigate()
    const handleCancelOrder = () => navigate('/')
    useEffect(() => {
        if(!!myRef && autoClick) {
            myRef?.current?.click()
        }
    }, [autoClick]);
    return (
        <Flex direction={'column'} color={'white'}>
             <> <Input {...register("userId")} defaultValue={account ? account.userId : ''} type={'hidden'}/>
            <FormControl isInvalid={!!errors.orderName}>
                <FormLabel fontSize={{lg:40}}>{t('name')}</FormLabel>
                <Input fontSize={{lg:40}} h={{lg:44}} defaultValue={isBonTacosAccount() ? '':(account.displayName || '' )} disabled={!!isAuth() && !isBonTacosAccount()} {...register('orderName', { required: true })} />
                {!!errors.orderName && (
                    <FormErrorMessage>{t('required')}</FormErrorMessage>
                )}
            </FormControl>
                 {!isBonTacosAccount() &&<FormControl isInvalid={!!errors.phoneNumber}>
                <FormLabel fontSize={{lg:40}}>{t('phone')}</FormLabel>
                <Input  fontSize={{lg:40}} h={{lg:44}} defaultValue={!!account ? account.phone : ''} disabled={!!isAuth()}
                       {...register('phoneNumber', {
                           pattern: {value: /\+\d{11}|07\d{7}|\+3891111./, message: t('wrongFormat')}
                    })}
                />
                <FormHelperText color={'white'}>
                    {/*Форматот мора да биде: +38911222333 или 075123123*/}
                </FormHelperText>
                {!!errors.phoneNumber && (
                    <FormErrorMessage>
                        {errors?.phoneNumber?.message?.toString() || ''}
                    </FormErrorMessage>
                )}
            </FormControl>}</>

            <Button bgColor={'brand.primary'} isDisabled={isLoading} borderRadius={{
                base: 'md',
                lg: '50px'
            }}
                    height={{
                        base: 12,
                        lg: 24
                    }}
                    fontSize={{
                        lg: 36
                    }}
                    type={'submit'} mt={5} ref={myRef}>
                {t('createOrder')}
            </Button>
            <Button mt={5} borderRadius={{
                base: 'md',
                lg: '50px'
            }}
                    height={{
                        base: 12,
                        lg: 24
                    }}
                    fontSize={{
                        lg: 36
                    }} onClick={() => handleCancelOrder()}>
                {t('startOver')}
            </Button>
        </Flex>
    )
}
